export enum AccountsPrivacyOptionsEnum {
	Public = '8c8997e1-317e-4da2-be6c-f91ba05813ff',
	Private = '7ab4bf4a-2e39-4c76-8d05-be36e5080c49',
}
